import { Injectable } from '@angular/core';
import { CommonHttpService } from '../common-http/common-http.service';
import { endPoints } from '../../shared/core/app.config';
import { Observable, ReplaySubject } from 'rxjs';
import { BaseProductTemplate } from '../../shared/models/product-template.model';
import { map, share } from 'rxjs/operators';
import { BaseConstantService} from '../constant/base-constant.service';
import { SharedSettingsService } from '../settings/settings-base.service';
import moment from 'moment';
import { SessionStorageService } from 'angular-web-storage';


@Injectable({
  providedIn: 'root'
})
export class BaseProductTemplateService {
  private apiUrl = endPoints.apiUrl;

  private getMasterProductUrl = this.apiUrl + endPoints.endPointName.getMasterProduct;
  private getProductTemplateUrl = this.apiUrl + endPoints.endPointName.getProductTemplate;

  constructor(private commonHttpService: CommonHttpService, private sharedSettingsService: SharedSettingsService,
              private sessionStorageService: SessionStorageService
  ) { }

  private productTemplateObservables: { [id: number]: Observable<BaseProductTemplate>; } = {};

  getMasterProduct(templateId: number) {
    return this.commonHttpService.httpGetServiceWithBearer(this.getMasterProductUrl + '/' + templateId);
  }

  getProductTemplate(templateId: number): Observable<BaseProductTemplate> {
    // Caching as queried in multiple places.
    if (!this.productTemplateObservables[templateId]) {
      const apiURL = this.getProductTemplateUrl;
      this.productTemplateObservables[templateId] = this.commonHttpService.httpGetServiceWithBearer(apiURL + '/' + templateId).pipe(
        share({
          connector: () => new ReplaySubject(1),
          resetOnError: false,
          resetOnComplete: false,
          resetOnRefCountZero: true,
        }))
    }
    return this.productTemplateObservables[templateId];
  }

  stashProductTemplateData(productId): Observable<void> {
    return this.getProductTemplate(productId).pipe(
      map(productTemplate => {
        this.stashProductData(productTemplate);
      })
    );
  }

  private stashProductData(product: BaseProductTemplate) {
    // Using inherent session storage as no dependency injection avaiable when retrieving values.
    sessionStorage.setItem('isExpiryDateasInceptionDate', String(product.isExpiryDateasInceptionDate));
    sessionStorage.setItem('policyTerm', String(product.policyTerm));
    sessionStorage.setItem('isB2cSingleCarrierMultiQuoteEnabled', String(product.isB2cSingleCarrierMultiQuoteEnabled));
    sessionStorage.setItem('isSuppressQuoteReview', String(product.isSuppressQuoteReview));
    sessionStorage.setItem('isExpiryDateThrougRating', String(product.isCalculatedThroughRating));
    sessionStorage.setItem('isUnderMasterPolicy', String(product.isUnderMasterPolicy));
    sessionStorage.setItem('isTermsAndConditionsAcceptanceRequiredToQuote', String(product.isTermsAndConditionsAcceptanceRequiredToQuote));

    // ** CustomerType can be >> 0-Both, 1-Person, 2-Company **//
    this.sharedSettingsService.productCustomerType = product.validCustomerType;
    this.sharedSettingsService.isMasterProduct = product.isMasterProduct;
    this.sharedSettingsService.isUnderMasterPolicy = product.isUnderMasterPolicy;
    this.sharedSettingsService.isB2cMultiCarrierQuotingEnabled = product.isB2cMultiCarrierQuotingEnabled;
    this.sessionStorageService.set(BaseConstantService.Key_IsATPDocumentDownloadForMCI, product.allowDocGenerationForMCI);
    this.sharedSettingsService.isDefaultListViewForMCI = product.isDefaultListView;

    this.sharedSettingsService.productName = product.productTemplateName;
    this.sharedSettingsService.isDDBeforeESignature = product.isDDBeforeESignature;
    this.sharedSettingsService.defaultCoverageTerm = product.defaultCoverageTerm;
    this.sharedSettingsService.isESignatureEnabled = product.isESignatureEnabled;
    this.sharedSettingsService.addPremiumOfMandatoryAndPreSelectedCoverages = product.addPremiumOfMandatoryAndPreSelectedCoverages;
    this.sharedSettingsService.editPrimaryCoveargeTermOnSecondaryCoveragePage = product.editPrimaryCoveargeTermOnSecondaryCoveragePage;
    this.sharedSettingsService.currencyIso4217 = product.currencyIso4217;
    this.sharedSettingsService.setAlternateViewOfSecondaryCoveragePage = product.alternateViewOfSecondaryCover;
    this.sharedSettingsService.setClearSelectionOnSecondaryCoverage = product.clearSelectionOnSecondaryCoverages;
    this.sharedSettingsService.cultureName = product.cultureName;
    this.sharedSettingsService.allowB2BUserToOnlySaveQuote = product.allowB2BUserToOnlySaveQuote;
    if (product.endDate) {
      this.sharedSettingsService.productValidityEndDate = moment(product.endDate, 'YYYY-MM-DD');
    }
  }
}
